<template>
  <div class="py-0 bg-gray-50">
    <!-- 顶部通栏工厂全景图 -->
    <section class="relative h-[400px] md:h-[500px] overflow-hidden">
      <img src="@/assets/images/Factory/FactoryBanner.png" alt="MLV Sound Insulation Felt Factory Panorama"
        class="w-full h-full object-cover">
      <div class="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center">
        <div class="text-center text-white px-6">
          <h2 class="text-3xl md:text-5xl font-bold mb-4">Factory Tour</h2>
          <p class="text-lg md:text-xl max-w-3xl mx-auto">Explore our professional MLV sound insulation felt production
            base</p>
        </div>
      </div>
    </section>

    <!-- 工厂实景九宫格区域 -->
    <section class="py-16">
      <div class="container mx-auto px-6">
        <div class="text-center mb-12">
          <h3 class="text-2xl md:text-3xl font-bold text-gray-800 mb-4">Our Production & Workshop</h3>
          <p class="text-gray-600 max-w-2xl mx-auto">
            Professional production environment, advanced automated equipment, and strict quality control process
          </p>
        </div>

        <!-- 九宫格图片列表 -->
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          <!-- 1. 自动化生产线（隔音毡核心生产） -->
          <div class="factory-card bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all group" v-for="item in data" :key="item.id">
            <div class="relative overflow-hidden h-64">
              <img :src="item.photoOssUrl" alt="Automated MLV Sound Insulation Felt Production Line"
                class="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110">
              <div
                class="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end">
                <p class="text-white p-4 text-sm md:text-base">{{ item.name }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Pagination :current-page="pageNum" :total="total" :page-size="pageSize" @page-change="handlePageChange" />
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import Pagination from '@/components/Pagination.vue';
import { pageFactoryLiveScene } from '@/api/factoryLiveScene'
const pageNum = ref(1)
const data = ref([])
const total = ref(0)
const pageSize = ref(9)
onMounted(() => {
  getPageFactoryLiveScene()
})
const getPageFactoryLiveScene = async () => {
  let res = await pageFactoryLiveScene({
    pageNum: pageNum.value,
    pageSize: pageSize.value
  })
  data.value = res.rows
  total.value = res.total
}
// 处理页码变更
const handlePageChange = (newPage) => {
    pageNum.value = newPage;
    getPageFactoryLiveScene()
};
</script>

<style scoped>
/* 工厂卡片hover效果优化 */
.factory-card {
  transition: all 0.3s ease-in-out;
}

.factory-card:hover {
  transform: translateY(-6px);
}

/* 顶部banner样式 */
section:first-child {
  margin-bottom: 0;
}

/* 文字主色（与原商品页一致） */
.text-primary {
  color: #3b82f6;
}

/* 响应式适配 */
/* @media (max-width: 767px) {
  .factory-card div {
    h-48; 
  }
  section.relative h2 {
    text-2xl md:text-3xl;
  }
  section.relative p {
    text-base;
  }
} */
</style>